import React from 'react'
import { Box, BoxBody, BoxHeader, BoxTitle } from '../ui/box'
import Link from '../helper/link'

export class NoReleasesYet extends React.PureComponent {
    render() {
        return (
            <>
                <Box>
                    <BoxHeader>
                        <BoxTitle>
                            <i className="fa fa-rocket burning" /> No Releases Yet!
                        </BoxTitle>
                    </BoxHeader>
                    <BoxBody>
                        <div className="alert alert-info">
                            <p>You have not created any releases yet.</p>
                            <p>
                                Releases in Tideways help you track performance improvements/degradations and reset occurrence counts for
                                errors, notifying you when they reappear.
                            </p>
                            <p>
                                Take a look at our{' '}
                                <a href="https://support.tideways.com/documentation/features/application-monitoring/releases.html">
                                    &quot;Release Tracking&quot; documentation
                                </a>{' '}
                                for details.
                            </p>
                            <p>You can create releases by</p>
                            <ul>
                                <li>
                                    using our{' '}
                                    <a href="https://support.tideways.com/documentation/setup/configuration/releases.html">REST API</a>
                                </li>
                                <li>
                                    clicking on a time block in your{' '}
                                    <Link route="XhprofOrganizationBundle.Application.show">project&apos;s performance screen</Link> and
                                    clicking &apos;Add Release at 13:37&apos;
                                </li>
                            </ul>
                        </div>
                    </BoxBody>
                </Box>
                <h4>Example</h4>
                <div className="text-center">
                    <img src="/images/empty-promos/no-releases-yet.png" />
                </div>
            </>
        )
    }
}
